module.exports = __webpack_public_path__ + "img/finland-male.4732f83b.png";